import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  OnInit,
  Output
} from '@angular/core';
import {
  AbstractControl,
  FormBuilder,
  FormGroup,
  ValidatorFn,
  Validators
} from '@angular/forms';

@Component({
  selector: 'ml-comment-form',
  template: `
    <form [formGroup]="form" fxLayout="column">
      <mat-form-field class="example-full-width">
        <textarea
          matInput
          [placeholder]="'leave a comment' | translate | sentancecase"
          formControlName="text"
        ></textarea>
      </mat-form-field>
    </form>
    <div fxLayout="row" fxLayoutAlign="end center">
      <button
        mat-raised-button
        color="primary"
        [disabled]="!form.valid"
        (click)="onPost()"
      >
        {{ 'post' | translate | titlecase }}
      </button>
    </div>
  `,
  styleUrls: ['./comment-form.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CommentFormComponent implements OnInit {
  form: FormGroup;

  @Output() post = new EventEmitter();
  constructor(private formBuilder: FormBuilder) {}

  ngOnInit() {
    this.form = this.formBuilder.group({
      text: ['', [Validators.required, this.containOnlySpaces()]]
    });
  }

  containOnlySpaces(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: boolean } | null => {
      if (control.value && control.value.match(/^\s*$/)) {
        return { spaces: true };
      }
      return null;
    };
  }
  onPost() {
    this.post.emit(this.form.value);
    this.form.reset();
  }
}
